import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import vetlioMockup from "../assets/img/vetlio-bg.png";

export const FeaturedProject = () => {
  const techStack = [
    "React",
    "TypeScript",
    "NestJS",
    "PostgreSQL",
    "REST APIs",
    "WhatsApp API",
  ];
  const highlights = ["Solo Built", "Real Client", "Production Ready"];

  return (
    <section className="featured-project" id="featured-project">
      <Container>
        {/* Section heading — matches Experience/Projects style */}
        <Row>
          <Col xs={12}>
            <h2 className="featured-section-heading">Featured Project</h2>
          </Col>
        </Row>

        {/* Two-column spotlight card */}
        <Row className="align-items-center g-5 mt-2">
          {/* Left — text content */}
          <Col lg={6}>
            <TrackVisibility partialVisibility once>
              {({ isVisible }) => (
                <div
                  className={`fp-text-col${isVisible ? " animate__animated animate__fadeInLeft" : ""}`}
                >
                  <span className="fp-eyebrow">✦ Spotlight</span>
                  <h3 className="fp-title">Vetlio</h3>
                  <p className="fp-subtitle">
                    Veterinary Practice Management System
                  </p>
                  <p className="fp-description">
                    A full-stack SaaS platform built solo from real client
                    requirements. Digitized veterinary clinic operations
                    including patient records, treatment lifecycle management,
                    appointment scheduling, and inventory control with
                    WhatsApp-based reminders and real-time stock validation.
                  </p>

                  {/* Highlights */}
                  <div className="fp-highlights">
                    {highlights.map((hl, i) => (
                      <span key={i} className="fp-highlight-pill">
                        {hl}
                      </span>
                    ))}
                  </div>

                  {/* Tech stack */}
                  <div className="fp-tech-stack">
                    {techStack.map((tech, i) => (
                      <span key={i} className="fp-tech-pill">
                        {tech}
                      </span>
                    ))}
                  </div>

                  {/* CTA buttons */}
                  <div className="fp-links">
                    <button
                      onClick={() =>
                        window.open(
                          "https://vetlio-landing.vercel.app/",
                          "_blank",
                        )
                      }
                      className="cta-btn primary-btn"
                    >
                      Visit Vetlio
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                        style={{ marginLeft: "8px" }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                        />
                      </svg>
                    </button>
                    <button
                      onClick={() => {}}
                      className="cta-btn secondary-btn"
                    >
                      Live Demo
                    </button>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>

          {/* Right — mockup card */}
          <Col lg={6}>
            <TrackVisibility partialVisibility once>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeInRight" : ""
                  }
                >
                  <div className="fp-mockup-card">
                    <img
                      src={vetlioMockup}
                      alt="Vetlio dashboard mockup"
                      className="fp-mockup-img"
                    />
                    <div className="fp-mockup-glow" />
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
